// API URL configuration

// Production API URL
const PROD_API_URL = 'https://backend-42ygumvdeq-lm.a.run.app';

// Test API URL (dev / local)
const TEST_API_URL = 'https://backend-42ygumvdeq-lm.a.run.app';

// npm start  → development mode → test backend
// npm run build → production mode → prod backend
// REACT_APP_API_URL орнатылған болса — екі жағдайда да оны пайдаланамыз
export const API_URL = process.env.REACT_APP_API_URL || PROD_API_URL;

export const MAP_API_URL = process.env.REACT_APP_MAP_API_URL;
export const TEST_API_URL_EXPORT = process.env.REACT_APP_TEST_API_URL || TEST_API_URL;

// Monitoring service URL
const PROD_MONITORING_URL = 'https://monitoring-service-237397542353.us-central1.run.app';
export const MONITORING_API_URL = process.env.REACT_APP_MONITORING_API_URL || PROD_MONITORING_URL;

// Bulk microservice URL
export const BULK_API_URL = 'https://bulk-microservice-42ygumvdeq-lm.a.run.app';